import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export const retrySubscriptionPaymentApi = (): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = '/billing/retry-subscription-payment/';

  return authApiService.POST(uri, {});
};
